import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import Loader from "./Loader";
import Navbar from "./Navbar";
import Hero from "./Hero";
import About from "./About";
import Skills from "./Skills";
import Projects from "./Projects";
import Services from "./Services";
import Contact from "./Contact";
import Footer from "./Footer";
import { useRevealOnScroll, useTilt } from "./hooks";
import { trackVisit } from "./tracker";

function Effects() {
  const bar = useRef(null);
  const glow = useRef(null);

  useRevealOnScroll();
  useTilt();

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      const h = document.documentElement;
      const p = h.scrollTop / Math.max(h.scrollHeight - h.clientHeight, 1);
      if (bar.current) bar.current.style.transform = `scaleX(${p})`;
    };
    const onMove = (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        if (glow.current)
          glow.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div className="progress" ref={bar} />
      <div className="cursor-glow" ref={glow} />
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    trackVisit();
  }, []);

  useEffect(() => {
    if (loading || !window.location.hash) return;
    const t = setTimeout(() => {
      const el = document.getElementById(window.location.hash.slice(1));
      if (el) el.scrollIntoView();
    }, 100);
    return () => clearTimeout(t);
  }, [loading]);

  return (
    <>
      {loading && <Loader onFinish={() => setLoading(false)} />}
      {!loading && (
        <>
          <Effects />
          <a className="skip-link" href="#about">Skip to content</a>
          <Navbar />
          <main>
            <Hero />
            <About />
            <Skills />
            <Projects />
            <Services />
            <Contact />
          </main>
          <Footer />
        </>
      )}
    </>
  );
}

export default App;
